export default __webpack_public_path__ + "static/media/logo.d991edf6.svg";